import React, { useEffect, useState } from "react";
import { useLocation, NavLink } from "react-router-dom";
import { Button, Nav, OverlayTrigger, Tooltip } from "react-bootstrap";
import LogLogo from "../../../../components/atoms/LogLogo";
import LogLogoXs from "../../../../components/atoms/LogLogoXs";
import LogButton from "../../../../components/atoms/LogButton";
import styled from "styled-components";
import { logOutAuth } from "../../../../redux/actions/auth";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { GoTriangleDown, GoTriangleRight } from "react-icons/go";
import { setCollapseOff, setCollapseOn } from "../../../../redux/actions/app";
import {
  COLOR_PRIMARY,
  COLOR_PRIMARY_DARK,
} from "../../../../constants/Colors";

const SideShadow = styled.div`
  box-shadow: 0 -20px 5px 0 rgb(0 0 0 / 5%), 0 -10px 10px 0 rgb(0 0 0 / 10%),
    0 2px 4px -1px rgb(0 0 0 / 1%) !important;
`;

const SideTitle = styled.p`
  font-size: 16px !important;
`;

const TooltipStyled = styled(Tooltip)`
  color: #0000;
  .tooltip-inner {
    font-size: 16px !important;
    margin-left: 10px;
    font-weight: bold;
    color: #ffff;
    background-color: ${COLOR_PRIMARY_DARK};
    opacity: 1;
  }
`;

const DivProfileSettings = styled.div`
  display: flex;
  justify-content: center;
  margin-top: auto;
`;

const SubmenuWrapper = styled.div`
  margin: 0px 15px 0px 15px;

  border-radius: 8px;
  background-color: rgba(157, 197, 55, 0.2); //rgba(0, 0, 0, 0.03);
`;

function Sidebar({ color, routes }) {
  const location = useLocation();
  const [width, setWidth] = useState(window.innerWidth);
  const dispatch = useDispatch();
  const history = useHistory();
  const { collapse } = useSelector((state) => state.appReducer);
  const [openMenu, setOpenMenu] = useState("");

  const toggleMenu = (menuName) => {
    setOpenMenu(openMenu === menuName ? "" : menuName);
  };

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);
  let isMobile = width <= 992;
  useEffect(() => {
    if (isMobile && !collapse) dispatch(setCollapseOn());
  }, [isMobile]);

  const activeRoute = (routeName) => {
    return location.pathname === routeName ||
      location.pathname.startsWith(routeName + "/")
      ? "active"
      : "";
  };

  return (
    <div
      className={`${collapse || isMobile ? "sidebar" : "sidebarxs"}`}
      data-color={color}
    >
      <div
        className={`${
          collapse || isMobile ? "sidebar-background" : "sidebarxs-background"
        }`}
      />
      <SideShadow
        className={`${
          collapse || isMobile ? "sidebar-wrapper" : "sidebarxs-wrapper"
        }`}
      >
        {collapse || isMobile ? (
          <div className="d-flex align-items-center justify-content-start pr-5 pt-4 pb-0 pl-5">
            <LogLogo />
          </div>
        ) : (
          <div className="d-flex align-items-center justify-content-center pt-4 pb-0">
            <LogLogoXs style={{ width: "48px", height: "48px" }} />
          </div>
        )}

        <div className="d-flex justify-content-start mt-3">
          {!isMobile ? (
            collapse ? (
              <GoTriangleRight
                onClick={() => dispatch(setCollapseOff())}
                className="text-primary h4 ml-1 mr-1 w-100 cursor-pointer"
              />
            ) : (
              <GoTriangleDown
                onClick={() => dispatch(setCollapseOn())}
                className="text-primary h4 ml-1 mr-1 w-100 cursor-pointer"
              />
            )
          ) : null}
        </div>
        <Nav>
          {routes.map((prop, key) => {
            if (prop.redirect) return null;

            const isActive = activeRoute(prop.layout + prop.path);
            const hasSubmenu = prop.submenu && prop.submenu.length > 0;
            const isOpen = openMenu === prop.name;

            const MenuItem = ({ insideSubmenu = false }) => (
              <div
                onClick={() => {
                  if (hasSubmenu) {
                    toggleMenu(prop.name);
                  } else {
                    toggleMenu("");
                  }
                }}
                style={{
                  cursor: hasSubmenu ? "pointer" : "default",
                  margin: insideSubmenu ? "" : "0px 15px",
                }}
              >
                {collapse || isMobile ? (
                  <NavLink
                    to={!hasSubmenu ? prop.layout + prop.path : "#"}
                    className="nav-link mt-0 pl-4 side-titles"
                    activeClassName="active"
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                    onClick={hasSubmenu ? (e) => e.preventDefault() : undefined}
                  >
                    <span
                      className={`${prop.icon} ${
                        isActive || "text-primary"
                      } mr-4`}
                      style={{ fontSize: 16 }}
                    ></span>
                    <SideTitle>{prop.name}</SideTitle>
                  </NavLink>
                ) : (
                  <NavLink
                    to={!hasSubmenu ? prop.layout + prop.path : "#"}
                    className="nav-link mt-0 side-titles"
                    activeClassName="active"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <OverlayTrigger
                      placement={"right"}
                      delay={{ hide: 450, show: 100 }}
                      overlay={
                        <TooltipStyled id={`tooltip-left`}>
                          {prop.name}
                        </TooltipStyled>
                      }
                    >
                      <span
                        className={`${prop.icon} ${
                          isActive || "text-primary"
                        } text-center`}
                        style={{ fontSize: 16 }}
                      ></span>
                    </OverlayTrigger>
                  </NavLink>
                )}
              </div>
            );

            return (
              <li
                className={prop.upgrade ? "active active-pro" : isActive}
                key={key}
              >
                {hasSubmenu && isOpen ? (
                  <SubmenuWrapper className={`${!collapse ? "mb-2" : ""}`}>
                    <MenuItem insideSubmenu={true} />
                    {prop.submenu.map((sub, subKey) => (
                      <li key={subKey}>
                        <NavLink
                          to={prop.layout + prop.path + sub.path}
                          className="nav-sub side-titles"
                          activeClassName="active"
                          onClick={() => toggleMenu("")}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginLeft: !collapse ? "0.5rem" : "3rem",
                            paddingLeft:
                              collapse || isMobile ? "1.5rem" : "0.5rem",
                          }}
                        >
                          {!collapse ? (
                            <OverlayTrigger
                              placement={"right"}
                              delay={{ hide: 450, show: 100 }}
                              overlay={
                                <TooltipStyled id={`tooltip-left`}>
                                  {sub.name}
                                </TooltipStyled>
                              }
                            >
                              <span
                                className={`${sub.icon} ${
                                  isActive || "text-primary"
                                } text-center mb-4`}
                                style={{ fontSize: 16 }}
                              ></span>
                            </OverlayTrigger>
                          ) : (
                            <SideTitle>{sub.name}</SideTitle>
                          )}
                        </NavLink>
                      </li>
                    ))}
                  </SubmenuWrapper>
                ) : (
                  <MenuItem />
                )}
              </li>
            );
          })}
          {isMobile && (
            <DivProfileSettings>
              <LogButton
                onClick={() => {
                  dispatch(logOutAuth());
                  history.push("/");
                }}
                block
                title="Cerrar sesión"
              />
            </DivProfileSettings>
          )}
        </Nav>
      </SideShadow>
    </div>
  );
}

export default Sidebar;
